/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './edit-weather-station.scss';

/* eslint-disable import/no-unresolved, import/default */

import editWeatherStationTemplate from './edit-weather-station.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editWeatherStation', [])
    .directive('agEditWeatherStation', EditWeatherStation)
    .name;

/*@ngInject*/
function EditWeatherStation() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            weatherStationId: '='
        },
        controller: EditWeatherStationController,
        controllerAs: 'vm',
        templateUrl: editWeatherStationTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditWeatherStationController($rootScope, $scope, $timeout, $translate, agTypes, userService, weatherStationService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.weatherStation = null;

    vm.save = save;
    vm.cancel = cancel;

    $scope.$watch('vm.weatherStationId', function() {
        if (vm.showData) {
            reload(vm.weatherStationId);
        }
    });

    function reload(weatherStationId) {
        if (!vm.weatherStation || !angular.equals(vm.weatherStation.id, weatherStationId)) {
            vm.loading = true;
            vm.origWeatherStation = null;
            vm.weatherStation = null;
            if (weatherStationId) {
                weatherStationService.getWeatherStation(weatherStationId).then(
                    function success(weatherStation) {
                        vm.origWeatherStation = weatherStation;
                        vm.weatherStation = angular.copy(weatherStation);
                        vm.loading = false;
                        resetFormState();
                    }
                );
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function() {
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function cancel() {
        vm.weatherStation = angular.copy(vm.origWeatherStation);
        resetFormState();
    }

    function save() {
       weatherStationService.saveWeatherStation(vm.weatherStation).then(function success(weatherStation) {
            vm.origWeatherStation = weatherStation;
            vm.weatherStation = angular.copy(weatherStation);
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
            $rootScope.$broadcast('weatherStationUpdated', vm.origWeatherStation);
        });
    }

}

